<script setup lang="ts">
import { useFathom } from '@/composables/fathom'

interface Props {
  border?: boolean
  subject?: string
  text?: string
  textSecondary?: string
  textClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  border: true,
  text: 'We\'re here to help',
  textSecondary: 'Contact a Team Member today',
  textClass: 'text-xl text-center pt-2 text-red-500 uppercase'
})

const { fathom, FathomEventNames, FathomEvents } = useFathom()
function trackEvent(e: any, payload: any = {}) {
  const events: any = {
    [FathomEventNames.PhoneCall]: () => fathom.trackEvent(FathomEvents.PhoneCall(payload))
  }
  events[e]()
}
</script>

<template>
  <div :class="props.border ? 'border-1 border-300 border-round p-2' : ''">
    <div :class="textClass">
      {{ props.text }}
    </div>
    <div
      v-if="textSecondary"
      class="text-lg font-italic text-center pt-2"
    >
      {{ props.textSecondary }}
    </div>
    <div class="my-4 flex align-items-center justify-content-center">
      <a
        class="border-round border-1 border-transparent hover:border-red-500 px-2 py-1 text-red-500 text-xl md:text-2xl font-bold text-decoration-none"
        href="tel:+12529771131"
        @click="trackEvent(FathomEventNames.PhoneCall, `12529771131-cta${props.subject ? `-${props.subject}` : ''}`)"
      >
        <fa-icon
          icon="fa fa-phone"
          class="hidden sm:inline text-gray-500 text-xl mr-2"
        />
        (252) 977-1131
      </a>
      <router-link
        class="lg:ml-4 router-link border-round border-1 border-transparent hover:border-red-500 px-2 py-1 text-red-500 text-xl md:text-2xl font-bold text-decoration-none"
        :to="`/customer-service?${props.subject ? `subject=${props.subject}` : ''}`"
      >
        <fa-icon
          icon="fa fa-envelope"
          class="mr-2 text-gray-500"
        />
        Email
      </router-link>
    </div>
  </div>
</template>
